import React, {useState} from "react";
import { t } from "../../../../../utils/i18n";

const SellerBankPaymentMethodDetails = ({
  isSeller,
  instructionsFrom,
  buyerUsername,
  buyerName,
  sellerUsername,
  sellerPaymentDetail,
  paymentMethod,
  transferTotal,
  referenceMessage,
}) => {
  if(!sellerPaymentDetail) return null;

  const detailsArray = sellerPaymentDetail.split(",");
  const [copied, setCopied] = useState(null);

  const sellerBankDetail = {
    accountHolderName: detailsArray[0].trim(),
    currency: detailsArray[1].trim(),
    bankName: detailsArray[2].trim(),
    accountNumber: detailsArray[3].trim(),
  };

  const handleCopy = (text, field) => {
      navigator.clipboard.writeText(text);
      setCopied(field);
      setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div>
        <p className="tradedetails-tradeinfo-title">
          <i className="fas fa-info-circle"></i>
          {" "}{isSeller ? t("p2p.details.my_bank_payment") : t("p2p.details.sellers_bank_payment")}
        </p>
        <div className="tradedetails-tradeinfo-section">
          <div>
            <div>
              <div>
                {!isSeller ? (
                  <p
                    className="tradedetails-instructions-from"
                    dangerouslySetInnerHTML={{ __html: t("p2p.details.use_bank_html") }}
                  />
                ) : (
                  <p
                    className="tradedetails-instructions-from"
                    dangerouslySetInnerHTML={{ __html: t("p2p.details.confirm_bank_html") }}
                  />
                )}
                <div className="bank_details">
                  {sellerBankDetail && (
                    <div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.payment_method")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{paymentMethod}
                          <button onClick={() => handleCopy(paymentMethod, "paymentMethod")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "paymentMethod" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.bank_table.bank_name_colon")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{sellerBankDetail?.bankName}
                          <button onClick={() => handleCopy(sellerBankDetail?.bankName, "sellerBankDetail?.bankName")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "sellerBankDetail?.bankName" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.account_name")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{sellerBankDetail?.accountHolderName}
                          <button onClick={() => handleCopy(sellerBankDetail?.accountHolderName, "sellerBankDetail?.accountHolderName")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "sellerBankDetail?.accountHolderName" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.account_number")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{sellerBankDetail?.accountNumber}
                          <button onClick={() => handleCopy(sellerBankDetail?.accountNumber, "sellerBankDetail?.accountNumber")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "sellerBankDetail?.accountNumber" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.account_currency")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{sellerBankDetail.currency}
                          <button onClick={() => handleCopy(sellerBankDetail.currency, "sellerBankDetail.currency")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "sellerBankDetail.currency" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.reference")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{referenceMessage || "hands polish"}
                          <button onClick={() => handleCopy(referenceMessage || "hands polish", "referenceMessage")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "referenceMessage" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.total")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{transferTotal}
                          <button onClick={() => handleCopy(transferTotal, "transferTotal")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "transferTotal" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p>{isSeller ? t("p2p.details.buyers_details") : t("p2p.details.sellers_details")}</p>
        <div>
          <div>
            <div>
              <div className="trade_bank_account">
                <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                  <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.common.name_colon")}</label> 
                  <span className="tradedetails-tradeinfo-payment-textvalues">{isSeller ? buyerName : sellerUsername}
                  </span>
                </div>
                <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                  <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.total")}</label>
                  <span className="tradedetails-tradeinfo-payment-textvalues">{transferTotal}
                    <button onClick={() => handleCopy(transferTotal, "transferTotal")} className="tradedetails-copybtn">
                      <i className={`fas fa-${copied === "transferTotal" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                    </button>
                  </span>
                </div>
                <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                <label className="tradedetails-tradeinfo-payment-textnames" title={t("p2p.details.ref_tip")}>{t("p2p.details.tx_ref")}</label>
                  <span className="tradedetails-tradeinfo-payment-textvalues">{referenceMessage || "hands polish"}
                    <button onClick={() => handleCopy(referenceMessage || "hands polish", "referenceMessage")} className="tradedetails-copybtn">
                      <i className={`fas fa-${copied === "referenceMessage" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SellerBankPaymentMethodDetails;
